module.exports = __webpack_public_path__ + "assets/images/EUR1.png";


//////////////////
// WEBPACK FOOTER
// ./client/app/assets/images/EUR1.png
// module id = 1362
// module chunks = 1